var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBronze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.96 60.8202C119.958 72.6511 116.448 84.2157 109.873 94.0517C103.299 103.888 93.9559 111.553 83.025 116.08C72.0942 120.606 60.0667 121.789 48.4634 119.48C36.8601 117.17 26.2022 111.472 17.8372 103.106C9.47221 94.7395 3.7759 84.0805 1.46855 72.4769C-0.838812 60.8732 0.346402 48.8459 4.87433 37.9158C9.40226 26.9857 17.0695 17.6437 26.9067 11.071C36.7438 4.49836 48.309 0.990235 60.1398 0.990234C67.9964 0.990234 75.7759 2.53786 83.0343 5.54472C90.2926 8.55158 96.8876 12.9588 102.443 18.5146C107.997 24.0705 112.404 30.6662 115.409 37.925C118.415 45.1839 119.961 52.9637 119.96 60.8202V60.8202Z",
    fill: "url(#paint0_linear_2102:3774)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.96 60.8202C110.958 70.8711 107.976 80.6956 102.39 89.0516C96.8049 97.4076 88.8672 103.92 79.5809 107.765C70.2946 111.61 60.0767 112.615 50.2192 110.653C40.3618 108.69 31.3075 103.85 24.2011 96.7419C17.0948 89.6342 12.2557 80.5789 10.2956 70.721C8.33552 60.8632 9.34251 50.6455 13.1892 41.36C17.036 32.0744 23.5497 24.138 31.9068 18.5543C40.2639 12.9705 50.089 9.99023 60.1398 9.99023C66.8145 9.99023 73.4237 11.3051 79.5901 13.8596C85.7565 16.4142 91.3593 20.1585 96.0785 24.8786C100.798 29.5987 104.541 35.2023 107.094 41.3692C109.648 47.5361 110.961 54.1456 110.96 60.8202V60.8202Z",
    fill: "url(#paint1_linear_2102:3774)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M105.01 60.8202C105.018 69.6964 102.393 78.3755 97.4675 85.7596C92.5419 93.1437 85.537 98.901 77.3388 102.303C69.1405 105.705 60.1174 106.6 51.4109 104.873C42.7043 103.146 34.7055 98.8759 28.4263 92.6023C22.1471 86.3287 17.8697 78.3337 16.1351 69.6287C14.4006 60.9236 15.2868 51.8997 18.6817 43.6985C22.0767 35.4972 27.8277 28.4871 35.2074 23.555C42.5871 18.6228 51.2639 15.9902 60.14 15.9902C72.0342 15.9876 83.4425 20.7086 91.8567 29.1153C100.271 37.522 105.002 48.9261 105.01 60.8202V60.8202Z",
    fill: "url(#paint2_linear_2102:3774)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M103.24 60.8202C103.244 69.3455 100.72 77.6804 95.9861 84.7708C91.2526 91.8611 84.5227 97.3885 76.6476 100.654C68.7724 103.919 60.1058 104.775 51.7439 103.115C43.382 101.454 35.7005 97.3505 29.6708 91.3236C23.6412 85.2968 19.5343 77.6171 17.8697 69.256C16.205 60.8949 17.0574 52.2279 20.3189 44.3512C23.5805 36.4745 29.1047 29.7421 36.1929 25.0053C43.2811 20.2685 51.6148 17.7402 60.14 17.7402C71.5674 17.7402 82.527 22.2784 90.6093 30.3569C98.6915 38.4354 103.235 49.3929 103.24 60.8202Z",
    fill: "url(#paint3_radial_2102:3774)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M103.24 60.8202C103.244 69.3455 100.72 77.6804 95.9861 84.7708C91.2526 91.8611 84.5227 97.3885 76.6476 100.654C68.7724 103.919 60.1058 104.775 51.7439 103.115C43.382 101.454 35.7005 97.3505 29.6708 91.3236C23.6412 85.2968 19.5343 77.6171 17.8697 69.256C16.205 60.8949 17.0574 52.2279 20.3189 44.3512C23.5805 36.4745 29.1047 29.7421 36.1929 25.0053C43.2811 20.2685 51.6148 17.7402 60.14 17.7402C71.5674 17.7402 82.527 22.2784 90.6093 30.3569C98.6915 38.4354 103.235 49.3929 103.24 60.8202Z",
    fill: "url(#paint4_radial_2102:3774)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1398 9.99023C50.089 9.99023 40.2639 12.9705 31.9068 18.5543C23.5497 24.138 17.036 32.0744 13.1892 41.36C9.34251 50.6455 8.33552 60.8632 10.2956 70.721C12.2557 80.5789 17.0948 89.6342 24.2011 96.7419C31.3075 103.85 40.3618 108.69 50.2192 110.653C60.0767 112.615 70.2946 111.61 79.5809 107.765C88.8672 103.92 96.8049 97.4076 102.39 89.0516C107.976 80.6956 110.958 70.8711 110.96 60.8202C110.961 54.1456 109.648 47.5361 107.094 41.3692C104.541 35.2023 100.798 29.5987 96.0785 24.8786C91.3593 20.1585 85.7565 16.4142 79.5901 13.8596C73.4237 11.3051 66.8145 9.99023 60.1398 9.99023V9.99023ZM60.1398 110.73C50.267 110.728 40.6165 107.799 32.4085 102.312C24.2005 96.8259 17.8037 89.0287 14.0269 79.9069C10.2501 70.785 9.26296 60.7481 11.1903 51.0652C13.1176 41.3823 17.8728 32.4884 24.8546 25.5079C31.8364 18.5275 40.7314 13.7741 50.4146 11.8487C60.0979 9.92334 70.1346 10.9125 79.2557 14.6911C88.3768 18.4697 96.1727 24.8681 101.658 33.0772C107.142 41.2863 110.07 50.9374 110.07 60.8102C110.051 74.0468 104.785 86.7359 95.4252 96.0956C86.0656 105.455 73.3764 110.722 60.1398 110.74V110.73Z",
    fill: "url(#paint5_linear_2102:3774)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.14 15.9902C51.2652 15.9902 42.5896 18.6221 35.2106 23.5529C27.8315 28.4837 22.0804 35.492 18.6846 43.6915C15.2888 51.891 14.4008 60.9134 16.1329 69.6176C17.8651 78.3218 22.1395 86.3169 28.4157 92.5917C34.6919 98.8664 42.6879 103.139 51.3925 104.869C60.0971 106.599 69.1192 105.709 77.318 102.312C85.5167 98.9142 92.5238 93.1615 97.4529 85.7814C102.382 78.4012 105.012 69.7251 105.01 60.8502C105.01 54.9583 103.849 49.1241 101.594 43.6807C99.3393 38.2374 96.034 33.2917 91.8673 29.1259C87.7006 24.9601 82.7541 21.656 77.3103 19.4021C71.8665 17.1483 66.032 15.9889 60.14 15.9902V15.9902ZM60.14 104.84C51.4377 104.84 42.9307 102.26 35.6949 97.4249C28.4592 92.5901 22.8196 85.7183 19.4893 77.6783C16.1591 69.6384 15.2877 60.7914 16.9855 52.2563C18.6832 43.7211 22.8738 35.881 29.0273 29.7275C35.1808 23.574 43.0209 19.3834 51.5561 17.6857C60.0912 15.9879 68.9382 16.8593 76.9781 20.1895C85.0181 23.5198 91.8899 29.1594 96.7247 36.3951C101.559 43.6309 104.14 52.1379 104.14 60.8402C104.132 72.5046 99.4929 83.6884 91.2421 91.9335C82.9914 100.179 71.8044 104.81 60.14 104.81V104.84Z",
    fill: "url(#paint6_linear_2102:3774)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1398 0.990238C48.3061 0.98826 36.7376 4.49555 26.8973 11.0686C17.057 17.6416 9.38691 26.985 4.85699 37.9174C0.327065 48.8497 -0.859195 60.8798 1.44823 72.4864C3.75565 84.0929 9.45312 94.7545 17.8201 103.123C26.1871 111.491 36.8477 117.191 48.4539 119.5C60.0601 121.809 72.0904 120.625 83.0235 116.097C93.9566 111.569 103.301 103.9 109.876 94.061C116.451 84.2218 119.96 72.6539 119.96 60.8202C119.964 52.963 118.419 45.182 115.415 37.9219C112.41 30.6619 108.004 24.0652 102.448 18.5088C96.8929 12.9524 90.2969 8.5453 83.0374 5.53937C75.7778 2.53344 67.9971 0.987609 60.1398 0.990238ZM60.1398 119.75C48.4826 119.75 37.0872 116.293 27.3945 109.817C17.7019 103.341 10.1474 94.1355 5.68637 83.3656C1.22534 72.5957 0.0581336 60.7449 2.33235 49.3116C4.60656 37.8784 10.2201 27.3763 18.463 19.1334C26.7059 10.8905 37.208 5.27697 48.6412 3.00275C60.0745 0.728541 71.9253 1.89575 82.6952 6.35678C93.4651 10.8178 102.67 18.3723 109.147 28.0649C115.623 37.7576 119.08 49.153 119.08 60.8102C119.067 76.439 112.853 91.4239 101.803 102.476C90.7525 113.528 75.7685 119.744 60.1398 119.76V119.75Z",
    fill: "url(#paint7_linear_2102:3774)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M14.9199 35.7904C20.464 25.7594 29.1847 17.8555 39.7107 13.3213C50.2368 8.78717 61.9713 7.87995 73.0693 10.7423C84.1672 13.6047 93.9991 20.0742 101.019 29.1339C108.039 38.1935 111.849 49.3293 111.85 60.7904C111.853 63.9543 111.558 67.1115 110.97 70.2204L115.71 70.8904L117.47 71.1404C118.077 67.7238 118.382 64.2604 118.38 60.7904C118.376 47.9691 114.141 35.5075 106.333 25.3384C98.5242 15.1692 87.5782 7.86102 75.1926 4.54725C62.807 1.23348 49.674 2.09938 37.8307 7.01065C25.9874 11.9219 16.0957 20.604 9.68994 31.7104C11.3599 33.1404 13.1099 34.5004 14.9199 35.7904Z",
    fill: "url(#paint8_linear_2102:3774)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M100.46 93.1503C94.5461 100.527 86.7226 106.14 77.8406 109.379C68.9587 112.618 59.3584 113.359 50.0845 111.522C40.8106 109.684 32.2182 105.339 25.2423 98.9575C18.2665 92.5764 13.1743 84.4042 10.5198 75.3303C8.01984 74.4403 5.51984 73.5303 3.08984 72.5903C5.40408 83.8238 10.9831 94.124 19.1274 102.2C27.2716 110.275 37.6187 115.767 48.8713 117.986C60.124 120.205 71.7813 119.053 82.3818 114.674C92.9822 110.295 102.054 102.884 108.46 93.3703C105.78 93.3303 103.13 93.2503 100.46 93.1503Z",
    fill: "url(#paint9_linear_2102:3774)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.46 71.17C126.86 7.99003 42.1499 -20.65 9.68994 31.71C40.8799 -24.96 130.28 7.64003 117.46 71.17Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.46 71.17C126.86 7.99003 42.1499 -20.65 9.68994 31.71C40.8799 -24.96 130.28 7.64003 117.46 71.17Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M109.07 69.0703C116.97 14.5103 45.74 -10.1997 18.46 34.9903C44.67 -13.9097 119.83 14.2303 109.07 69.0703Z",
    fill: "url(#paint10_linear_2102:3774)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.79 67.4204C109.71 20.9904 47.4 -0.109636 23.46 38.4004C46.46 -3.26964 112.21 20.7004 102.79 67.4204Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2298 103.8C71.2298 127.8 38.0598 121.63 16.0598 97.8003C1.45981 81.8803 -2.98019 56.9903 8.45981 33.5703C-22.9002 90.1403 52.2798 148.46 99.2298 103.8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M92.9998 97.7902C50.9998 133.54 -7.83021 86.4002 15.8998 39.2002C-11.5402 87.4902 52.2998 136.11 92.9998 97.7902Z",
    fill: "url(#paint11_linear_2102:3774)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M91.3199 90.8501C57.8199 123.85 4.11993 85.8501 21.1799 43.8501C1.00993 86.9901 59.0999 125.99 91.3199 90.8501Z",
    fill: "url(#paint12_linear_2102:3774)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2102:3774",
    x1: 18.6499,
    y1: 19.3202,
    x2: 97.0898,
    y2: 97.7702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0BFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C67B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C2824E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BD794C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#B46849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#B26443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B1603F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BA5A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C2713E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C06E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B96434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#AE5326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#A14018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#A64820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B35E34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#C88156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CA8459"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2102:3774",
    x1: 8.38985,
    y1: 9.07023,
    x2: 107.54,
    y2: 108.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E0BFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C67B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C2824E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BD794C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#B46849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#B26443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B1603F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BA5A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C2713E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A14018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A64820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B35E34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#CA8459"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2102:3774",
    x1: 30.43,
    y1: 26.7302,
    x2: 94.91,
    y2: 100.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0BFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C67B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C2824E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BD794C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B46849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#B1603F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#B86D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CD997C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#DBB599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E0BFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EEDCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FAF5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#CA8459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C2713E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AD5226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A14018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2102:3774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.4601 31.7002) scale(69.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CA8459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C2713E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#BD6A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#B0572A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A14018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2102:3774",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6901 102.03) scale(85.59)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#050302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#140C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2E1B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#512F1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7E4928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B46939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C2713E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CA8459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2102:3774",
    x1: 39.2698,
    y1: 14.4802,
    x2: 79.6798,
    y2: 104.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2824E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#BD794C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B46849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B26443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#B1603F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BA5A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A14018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A14018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2102:3774",
    x1: 11485.8,
    y1: 2843.7,
    x2: 15112.2,
    y2: 10897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2824E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#BD794C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B46849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B26443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#B1603F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BA5A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A14018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A14018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2102:3774",
    x1: 12539.5,
    y1: 2220.68,
    x2: 22282.2,
    y2: 15377.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2824E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#BD794C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B46849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B26443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#B1603F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BA5A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A14018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A14018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2102:3774",
    x1: 82.6199,
    y1: 5.26036,
    x2: 63.9999,
    y2: 50.4204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#CA8459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C2713E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#B46939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#7E4928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#512F1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2E1B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#140C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#050302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2102:3774",
    x1: 55.3198,
    y1: 94.3803,
    x2: 54.4198,
    y2: 116.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E6C4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#CF8B6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C06843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#BA5A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A14018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A44720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#AD5936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BC765A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D09F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E9D3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2102:3774",
    x1: 13918.2,
    y1: 4188.37,
    x2: 14714,
    y2: 1454.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E6C4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#CF8B6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C06843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#BA5A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A14018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A44720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#AD5936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BC765A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D09F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E9D3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2102:3774",
    x1: 19100.2,
    y1: -8798.82,
    x2: 17074.8,
    y2: -6090.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E6C4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#CF8B6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C06843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#BA5A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A14018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A44720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#AD5936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BC765A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D09F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E9D3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2102:3774",
    x1: 11870.9,
    y1: 4439.77,
    x2: 10538.3,
    y2: 6390.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E6C4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#CF8B6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C06843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#BA5A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A14018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#A44720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#AD5936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BC765A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D09F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E9D3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.a9cd99e77503c1648661cb4b4711c7d5.svg";
export { ForwardRef as ReactComponent };